import * as React from 'react';
import classNames from 'classnames';
import { Component } from 'react';

interface Props {
  isActive: boolean;
  isSelected: boolean;
  isToday: boolean;
  isNextMonth: boolean;
  isPrevMonth: boolean;
  onClick: () => void;
  dayName: number | string;
  eventTypes?: string[];
}

export class DayPanel extends Component<Props> {
  render() {
    const isOut = this.props.isNextMonth || this.props.isPrevMonth;
    const classes = classNames({
      'cal-cell': true,
      'cal-cell--out': isOut,
      'cal-cell--today': this.props.isToday === true,
      'cal-cell--sel': this.props.isSelected === true
    });

    return (
      <button className={classes} onClick={isOut ? undefined : this.props.onClick} type="button" disabled={isOut}>
        <span className="cal-cell__n">{this.props.dayName}</span>
        {this.props.eventTypes && this.props.eventTypes.length > 0 && !isOut ? (
          this.props.eventTypes.length >= 3 ? (
            <span className="cal-event-count" aria-label={`${this.props.eventTypes.length} events`}>
              {this.props.eventTypes.length}
            </span>
          ) : (
            <span className="cal-dots" aria-hidden="true">
              {this.props.eventTypes.map((type, index) => (
                <span key={`${type}_${index}`} className={`cal-dot cal-dot--${type}`} />
              ))}
            </span>
          )
        ) : null}
      </button>
    );
  }
}
